import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, useForm } from "react-hook-form";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useQyCreateTransaction } from "@factory/query/transaction.query";
import { TransactionFormRule, TransactionFormSchema } from "@factory/form/form.rule";
import { transactionFormDefault } from "@factory/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export function useNewTransaction() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateTransaction } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Transaction is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addTransaction, isLoading: isCreating } =
    useQyCreateTransaction(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<TransactionFormSchema>({
    defaultValues: transactionFormDefault,
    resolver: zodResolver(TransactionFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: TransactionFormSchema) => {
    const formData = mapCreateTransaction(form);
    addTransaction(formData);
  };
  const handleValidateError = (err: FieldErrors<TransactionFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
